import AuthorizePlugbookCall from '@components/AuthorizePlugbookCall'
import { subscribeToKeychainState } from '@core/keychainStateSubscriber'
import { Principal } from '@icp-sdk/core/principal'
import { WalletUnlock } from '@modules/Wallet/Components/WalletUnlock'
import { WalletSetup } from '@modules/WalletSetup'
import { getStatus } from '@plug-core/handlers/walletActions/wallet'
import { WalletStatusResponse } from '@plug-core/interfaces/walletActions'
import { useConnectionProvider, useCurrentWallet, useWalletProperties } from '@plug-core/state'
import { getOisyAgent } from '@utils/oisy'
import { disconnectFromPlugExtension, getPlugExtension } from '@utils/plugExtension'
import React, { PropsWithChildren, useEffect, useState } from 'react'

export default ({ children }: PropsWithChildren) => {
  const [accountState, setAccountState] = useState<WalletStatusResponse>({
    isReady: false,
    hasVault: false,
    hasPassword: false,
    unlocked: false,
  })

  const { provider, setProvider } = useConnectionProvider()
  const { currentWallet } = useCurrentWallet()
  const { walletPlugbookRecords } = useWalletProperties()

  useEffect(() => {
    getStatus().then(setAccountState)
    subscribeToKeychainState(setAccountState)
  }, [])

  useEffect(() => {
    const getPlugState = async () => {
      if (provider !== 'plug') return

      const plug = getPlugExtension()
      if (plug) {
        const isConnected = await plug.isConnected()

        if (!isConnected) {
          disconnectFromPlugExtension()
          setProvider(null)
        }
      }
    }

    getPlugState()
  }, [provider])

  useEffect(() => {
    const getOisyState = async () => {
      if (provider !== 'oisy' || !currentWallet) return

      const agent = getOisyAgent()
      const agentPrincipal = await agent.getPrincipal()

      if (currentWallet !== agentPrincipal.toString()) {
        agent.replaceAccount(Principal.fromText(currentWallet))
      }
    }

    getOisyState()
  }, [provider, currentWallet])

  const isII = provider === 'internet-identity-legacy' || provider === 'internet-identity-v2'

  if (!accountState.isReady) {
    return null
  } else if (provider === 'oisy' && !walletPlugbookRecords[currentWallet]) {
    return <AuthorizePlugbookCall />
  } else if ((isII || !provider) && (!accountState.hasVault || !accountState.hasPassword)) {
    return <WalletSetup />
  } else if (provider && !isII) {
    return children
  } else if (!accountState.unlocked) {
    return <WalletUnlock />
  } else {
    return children
  }
}
